import React from 'react';
import {connect} from 'react-redux';
import Alert from './Alert';
import {surveyExportComplete, dashboardExportComplete} from '../actions/action_export';

const Downloader = ({dashboardExportComplete, surveyExportComplete, items, dashboards, error}) => {
    const doDownload = (id, exportedData, completeAction) => {
        const {type, name, data} = exportedData;
        const url = window.URL.createObjectURL(new Blob([data], {type}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        completeAction(id);
    };

    React.useEffect(() => {
        for (const [id, data] of Object.entries(items)) {
            if (data.data) {
                doDownload(id, data.data, surveyExportComplete);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);

    React.useEffect(() => {
        for (const [id, data] of Object.entries(dashboards)) {
            if (data.data) {
                doDownload(id, data.data, dashboardExportComplete);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dashboards]);

    return <Alert error={error} />;
};

const mapStateToProps = (state) => ({
    items: state.exports.items,
    dashboards: state.exports.dashboards,
    error: state.exports.error,
});

export default connect(mapStateToProps, {dashboardExportComplete, surveyExportComplete})(Downloader);
